import { createActionGroup, emptyProps, props } from '@ngrx/store'

import { ChatMessage, SendFeedbackPayload } from '../../../types/ai.types'

const errorProps = props<{ statusCode: number; errorMsg?: any }>

export const AiAssistantActions = createActionGroup({
  source: 'AiAssistant',
  events: {
    getAnswer: props<{ prompt: string }>(),
    getAnswerEventStream: props<{ response: Partial<ChatMessage> }>(),
    getAnswerStreamCompleted: emptyProps(),
    getAnswerStreamFailure: errorProps(),

    sendFeedback: props<{ payload: SendFeedbackPayload }>(),

    discardOutcome: emptyProps(),
  },
})
